/**
 * Names of errors that are part of the [environment]{@link module:environment} module's domain
 * @memberof module:environment
 * @enum {string}
 * @readonly
 * @inner
 */
const EnvironmentError = {
  /**
   * Returned when your try to use a method that is not supported in the context
   * of your current environment (OS/Device)
   */
  METHOD_NOT_SUPPORTED: 'METHOD_NOT_SUPPORTED'
}
export default EnvironmentError
